/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/DeviceWriteOff.css';
import FormContainer from '../CustomElements/FormContainer';
import CustomButton from '../CustomElements/CustomButton';
import DateSelector from '../CustomElements/DateSelector';
import CustomTextarea from '../CustomElements/CustomTextarea';
import CustomTitle from '../CustomElements/CustomTitle';
import CustomContainer from '../CustomElements/CustomContainer';
import ConfirmationPage from '../CustomElements/ConfirmationPage';
// Кастомные хуки
import { useButtonValidation } from '../../customHook/useButtonValidation';
import useSuccessListener from '../../customHook/useSuccessListener';
// Утилиты
import { handleUniversalChange } from '../../utils/formUtils';
import { convertToDate, transformFieldsToMoscowStart } from '../../utils/convertToDate';
// Действия Redux
import { transferDeviceForWriteOff } from '../../redux/actions/devices.action';
import { load } from '../../redux/actions/loader.action';
import FilePicker from '../FileManager/FilePicker';
import { omitFields } from '../../utils/omitFields';

function DeviceWriteOff({ currentDevice, closeModal, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  //состояние для отображения подтверждения списания
  const [writeOffSuccess, setWriteOffSuccess] = useState(false);

  // Состояние для формы
  const initialFormData = {
    deviceId: currentDevice.id,
    date: '',
    attachment: '',
    reason: '',
  };
  const [formData, setFormData] = useState(initialFormData);

  // Функция для проверки валидности формы
  const isButtonDisabled = useButtonValidation(formData);

  const handlerCloseModal = () => {
    setFormData(initialFormData);
    setWriteOffSuccess(false);
    closeModal();
  };

  // Обработчик отправки формы
  const handlerSubmit = (event) => {
    event.preventDefault();
    //переводим в состояние загрузки
    dispatch(load());
    // Удаляем поля, которые не нужно отправлять
    const formWithoutExcluded = omitFields(formData, ['deviceId', 'attachmentName']);
    const payload = transformFieldsToMoscowStart(formWithoutExcluded, ['date']);
    // Отправляем данные на сервер через Redux
    dispatch(
      transferDeviceForWriteOff({
        payload: payload,
        typeId: currentDevice?.typeId,
        deviceId: formData?.deviceId,
      })
    );
  };

  //отслеживаем выполнение запроса
  useSuccessListener(setFormData, initialFormData, closeModal);

  return (
    <CustomContainer>
      <CustomTitle
        titleText={t?.deviceWriteOff || 'СПИСАНИЕ УСТРОЙСТВА'}
        deviceType={currentDevice.type}
        deviceId={currentDevice.id}
      />
      {writeOffSuccess && (
        <ConfirmationPage
          confirmText={t?.confirmWriteOff || 'Вы уверены, что хотите списать устройство?'}
          confirmButtonText={t?.writeOffButton || 'Списать'}
          cancelButtonText={t?.cancelButton || 'Отменить'}
          onConfirm={handlerSubmit} // Функция, которая должна быть вызвана при подтверждении
          onCancel={handlerCloseModal} // Функция для закрытия модального окна или отмены действия
        />
      )}
      {!writeOffSuccess && (
        <FormContainer>
          <DateSelector
            column="left"
            width="100%"
            height="var(--sadr-font-size-60)"
            label={t?.writeOffDate || 'Дата списания *'}
            selectedDate={formData.date}
            setSelectedDate={(date) => handleUniversalChange(formData, setFormData, null, 'date', date, 'date')}
            name="date"
            placeholder={t?.selectDate || 'Выберите дату'}
            minDate={convertToDate(currentDevice?.lastActionDate)}
            maxDate={new Date()}
          />
          <FilePicker
            column="right'"
            label={`${t?.writeOffActTitle} *` || 'Акт списания *'}
            formData={formData}
            setFormData={setFormData}
            fieldName="attachmentName"
            fieldIdName="attachment"
            rowSpan={2}
          />
          <CustomTextarea
            type="textArea"
            onChange={(event) => handleUniversalChange(formData, setFormData, event)}
            name="reason"
            columnspan={2}
            label={t?.reasonLabel || 'Причина списания *'}
            placeholder={t?.writeOffReason || 'Укажите причину списания'}
            width="100%"
            height="var(--sadr-font-size-200)"
            value={formData.reason}
          />
          <CustomButton
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
            color={isButtonDisabled ? '#ADADAD' : ''}
            text={t?.writeOffDevice || 'Списать устройство'}
            disabled={isButtonDisabled}
            onClick={() => setWriteOffSuccess(true)}
            isButton
          />
        </FormContainer>
      )}
    </CustomContainer>
  );
}

export default DeviceWriteOff;
